// extracted by mini-css-extract-plugin
export var deliveryRow = "_rm-a";
export var fixedHeight = "_rm-4";
export var freightLogo = "_rm-9";
export var fullWidth = "_rm-3";
export var priceColumn = "_rm-5";
export var radioSelected = "_rm-7";
export var radioUnselected = "_rm-6";
export var selectedOption = "_rm-2";
export var selectedOptionContainer = "_rm-1";
export var selection = "_rm-0";
export var tallSkeletonText = "_rm-8";